import React, { useState } from "react";
import PhoneNumberInput from "./PhoneNumberInput";
import CustomInput from "../../Common/CustomInput";
import CustomDatePicker from "../../Common/CustomDatePicker";
import toast from "react-hot-toast";
import axios from "axios";

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;
const SignupForm = ({ setOpenSignUp, onRegistered }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dialCode: "+91",
    phoneNumber: "",
    dob: "",
    gender: "",
  });


  const validateForm = () => {
    let errors = {};
    errors.firstName = formData.firstName ? "" : "First Name is required";
    errors.lastName = formData.lastName ? "" : "Last Name is required";
    errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
      ? ""
      : "Please enter a valid email address";
    errors.phoneNumber =
      formData.phoneNumber.length === 10
        ? ""
        : "Phone number must be exactly 10 digits";
    errors.dob = formData.dob ? "" : "Date of birth is required";
    errors.gender = formData.gender ? "" : "Gender is required";
    setFormErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };

  const handleCheckboxChange = () => setIsChecked(!isChecked);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    let errors = { ...formErrors };
    if (name === "firstName")
      errors.firstName = value ? "" : "First Name is required";
    if (name === "lastName")
      errors.lastName = value ? "" : "Last Name is required";
    if (name === "email")
      errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? ""
        : "Please enter a valid email address";
    if (name === "dob") errors.dob = value ? "" : "Date of birth is required";
    if (name === "gender") errors.gender = value ? "" : "Gender is required";
    setFormErrors(errors);
  };

  const handlePhoneNumberChange = (value) => {
    if (value.length <= 10) {
      setFormData((prev) => ({ ...prev, phoneNumber: value }));
    }
    let errors = { ...formErrors };
    errors.phoneNumber = /^\d{10}$/.test(value)
      ? ""
      : "Phone number must be exactly 10 digits";
    setFormErrors(errors);
  };

  // const handlePhoneNumberChange = (value) => {
  //   if (/^\d{0,10}$/.test(value)) {
  //     setFormData((prev) => ({ ...prev, phoneNumber: value }));
  //   }

  //   const errors = { ...formErrors };
  //   errors.phoneNumber = value.length === 10
  //     ? ""
  //     : "Phone number must be exactly 10 digits";
  //   setFormErrors(errors);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const {
          firstName,
          lastName,
          email,
          dob,
          gender,
          phoneNumber,
          dialCode,
        } = formData;
        const payload = {
          firstName,
          lastName,
          email,
          dob,
          gender,
          phoneNumber: {
            dialCode,
            value: phoneNumber,
          },
        };

        await axios.post(`${ACCOUNTS_URL}/auth/signup`,payload);
        setOpenSignUp(false);
        toast.success("Account created. Check your e-mail for a verification code.");
        await onRegistered(email);
      } catch (error) {
        console.log(error)
        toast.error(error?.response?.data?.error?.message);
      }
    }
  };

  return (
    <div className="rounded-3xl border border-slate-200 bg-white/90 p-7 shadow-soft backdrop-blur sm:p-9">
      <h2 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Create your account</h2>
      <p className="mt-2 text-sm text-slate-600">It takes less than a minute. You'll then choose your hospital or clinic.</p>

      <div className="mt-6 flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <CustomInput name="firstName" label="First name" type="text" placeholder="First name" value={formData.firstName} onChange={handleInputChange} error={formErrors.firstName} />
          <CustomInput name="lastName" label="Last name" type="text" placeholder="Last name" value={formData.lastName} onChange={handleInputChange} error={formErrors.lastName} />
        </div>
        <CustomInput name="email" label="Email address" type="email" placeholder="you@example.com" value={formData.email} onChange={handleInputChange} error={formErrors.email} />
        <CustomDatePicker id="dob" label="Date of birth" value={formData.dob} isInvalid={!!formErrors.dob} errorMessage={formErrors.dob} onChange={handleInputChange} />
        <div>
          <label className="mb-1.5 block text-sm font-medium text-slate-700">Phone number</label>
          <PhoneNumberInput formData={formData} onChange={handlePhoneNumberChange} setFormData={setFormData} />
          {formErrors.phoneNumber && <p className="mt-1.5 text-xs text-rose-600">{formErrors.phoneNumber}</p>}
        </div>
        <fieldset>
          <legend className="mb-1.5 block text-sm font-medium text-slate-700">Gender</legend>
          <div className="grid grid-cols-3 gap-2">
            {["Male", "Female", "Other"].map((gender) => {
              const checked = formData.gender === gender.toLowerCase();
              return (
                <label
                  key={gender}
                  className={`cursor-pointer rounded-xl border px-3 py-2.5 text-center text-sm font-medium transition ${
                    checked ? "border-brand-500 bg-brand-50 text-brand-700" : "border-slate-300 text-slate-600 hover:bg-slate-50"
                  }`}
                >
                  <input type="radio" name="gender" value={gender.toLowerCase()} checked={checked} onChange={handleInputChange} className="sr-only" />
                  {gender}
                </label>
              );
            })}
          </div>
          {formErrors.gender && <p className="mt-1.5 text-xs text-rose-600">{formErrors.gender}</p>}
        </fieldset>
      </div>

      <label htmlFor="terms" className="mt-5 flex items-start gap-2.5 text-sm text-slate-600">
        <input type="checkbox" id="terms" checked={isChecked} onChange={handleCheckboxChange} className="mt-0.5 h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500" />
        <span>
          I agree to the Health Frigate{" "}
          <a href="/terms" target="_blank" rel="noreferrer" className="hf-link">Terms of Service</a> and{" "}
          <a href="/privacy" target="_blank" rel="noreferrer" className="hf-link">Privacy Policy</a>.
        </span>
      </label>

      <button onClick={handleSubmit} disabled={!isChecked} className="hf-btn mt-5 py-3.5 text-base">
        Create account
      </button>
      <p className="mt-6 text-center text-sm text-slate-600">
        Already have an account?{" "}
        <button type="button" className="hf-link" onClick={() => setOpenSignUp(false)}>
          Sign in
        </button>
      </p>
    </div>
  );
};

export default SignupForm;
